import { connect } from 'react-redux';
import { globalKey } from 'data/sharedKeys';
import { loadAccount } from 'data/accounts/accounts.actions';
import HomePageContainer from './HomePageContainer';

const actions = {
  loadAccount: () => loadAccount(globalKey)
};

function mapStateToProps(state) {
  return {
    account: { ...state.accounts[globalKey] }
  };
}

export default connect(mapStateToProps, actions)(HomePageContainer);
